import React from "react";
import WordGridHowTo from "./WordGridHowTo";

/** Route entry: `/howto/puzzle/hidden-message` */
export default function HowToWordGrid() {
    return <WordGridHowTo gridVariant="HIDDEN_MESSAGE" />;
}
